import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PanAppState } from '@panamax/app-state';
import {
  IMPORT_ORDERS_ACTIONS,
  orderSelectors,
  ordersFiltersReducer,
} from '@usf/ngrx-order';
import { filter, map, tap, withLatestFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportedOrdersService {
  constructor(
    private store: Store,
    private panAppState: PanAppState,
  ) {}

  importedOrdersById$(importOrderIdentifier: string) {
    return this.store.select(
      orderSelectors.selectImportedOrdersById(importOrderIdentifier),
    );
  }

  importedOrdersByDate$(importedDate: string) {
    return this.store
      .select(orderSelectors.selectImportedOrdersByDate(importedDate))
      .pipe(
        withLatestFrom(this.panAppState.user$),
        map(([orders, user]) =>
          orders.filter(
            order =>
              order?.orderHeader?.importOrderTakerId ===
                user?.ecomUserId.toString() ||
              order?.orderHeader?.importOrderTakerId === user?.userId,
          ),
        ),
      );
  }

  pollImportedOrdersById(importOrderIdentifier: string) {
    this.store.dispatch(
      IMPORT_ORDERS_ACTIONS.pollGetImportedOrders({ importOrderIdentifier }),
    );
  }
}
